module.exports = __webpack_public_path__ + "static/media/logo.fafb30c0.png";